'use client';

interface Props {
  voicebox: boolean;
  rvc: boolean;
}

export default function ServiceStatus({ voicebox, rvc }: Props) {
  return (
    <div className="flex items-center gap-4 text-xs font-mono">
      <span className="text-slate-500 uppercase tracking-widest">Services</span>
      <span className={`flex items-center gap-1.5 ${voicebox ? 'text-emerald-400' : 'text-red-400'}`}>
        <span className={`w-2 h-2 rounded-full ${voicebox ? 'bg-emerald-400' : 'bg-red-500'}`} />
        Voicebox
      </span>
      <span className={`flex items-center gap-1.5 ${rvc ? 'text-emerald-400' : 'text-red-400'}`}>
        <span className={`w-2 h-2 rounded-full ${rvc ? 'bg-emerald-400' : 'bg-red-500'}`} />
        RVC
      </span>
      {(!voicebox || !rvc) && (
        <span className="text-slate-500 italic">— see setup guide below</span>
      )}
    </div>
  );
}
